var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVCoverRw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 325",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f4f4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400,325H0V0h400v325ZM333.27,57.09l-132.52-12.05-135.91,12.05v207.06l134.21,15.81,136.09-15.44-1.88-207.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCoverRw);
export default __webpack_public_path__ + "static/media/v_cover_rw.d5bde287dc7baaf2c537da8262a68bd9.svg";
export { ForwardRef as ReactComponent };